<template>
  <div class="index-container">
    <div class="index-header">
      <mtdm-navigation-bar :title="$getText('wenshu_mobile_alert_information', '告警信息')" left-icon="" fixed
                           :right-text="$getText('wenshu_mobile_alert_cycle_settings', '设置告警周期')"
                           @click-right="open_user_setting"></mtdm-navigation-bar>
    </div>
    <div style="height: 44px"></div>
    <div class="index-list">
      <mtd-card v-for="item in alarm_list" :key="item.id">
        <div @click="show_detail(item.id, item.filename)">
          <mtd-row :gutter="8">
            <mtd-col :span="24" style="padding-bottom: 13px">
              <span class="list-card-title">
                <span class="filename-span">{{ item.filename }}</span>
              </span>
              <mtdm-tag type="ghost" textColor="#F5483B" style="margin-left: 15px">
                {{ item.secretLevel }}
              </mtdm-tag>
              <div style="float: right"><i class="mtdmicon-right"></i></div>
            </mtd-col>
          </mtd-row>
          <mtd-row :gutter="8">
            <mtd-col :span="6" style="padding-right: 2px">
              <div class="data-show">
                <mtd-icon name="visibility-on-o" style="font-size: 20px;vertical-align: middle;"/>
                <span style="margin-left: 2px">{{ $getText('wenshu_mobile_view', '查看') }} {{ item.viewUserCnt }}</span>
              </div>
            </mtd-col>
            <mtd-col :span="6" style="padding-right: 2px">
              <div class="data-show">
                <mtd-icon name="share-o" style="font-size: 20px;vertical-align: middle;"/>
                <span style="margin-left: 2px">{{ $getText('wenshu_mobile_forward', '转发') }} {{ item.transferUserCnt }}</span>
              </div>
            </mtd-col>
            <mtd-col :span="6" style="padding-right: 2px">
              <div class="data-show">
                <mtd-icon name="download-o" style="font-size: 20px;vertical-align: middle;"/>
                <span style="margin-left: 2px">{{ $getText('wenshu_mobile_download', '下载') }} {{ item.downloadUserCnt }}</span>
              </div>
            </mtd-col>
            <mtd-col :span="6" style="padding-left: 2px">
              <div class="data-show">
                <mtd-icon name="file-send" style="font-size: 20px;vertical-align: middle;"/>
                <span style="margin-left: 2px">{{ $getText('wenshu_mobile_external_share', '外发') }} {{ item.outputUserCnt }}</span>
              </div>
            </mtd-col>
          </mtd-row>
        </div>
      </mtd-card>
    </div>
    <div style="width: 100%;background-color: #fff; padding-top: 5px;" v-if="alarm_list.length !== query_params.tn">
      <mtdm-button type="text-primary" width="full" size="tiny" @click="change_page"
                   style="color: rgba(0, 0, 0, 0.24);">
        {{ $getText('ws_mobile_load_more', '加载更多') }}
      </mtdm-button>
    </div>
    <div style="width: 100%;background-color: #fff; padding-top: 5px;" v-if="alarm_list.length === 0">
      <mtdm-button type="text-primary" width="full" size="tiny" style="color: rgba(0, 0, 0, 0.24);">
        {{ $getText('wenshu_web_no_data', '暂无数据') }}
      </mtdm-button>
    </div>
    <!-- 设置的弹窗 -->
    <mtdm-slide-modal v-model="user_setting_visible" :title="$getText('wenshu_mobile_alert_cycle_settings', '告警周期设置')">
      <div class="slide-content">
        <div class="content-main">
          <div class="content-label-title">{{ $getText('wenshu_mobile_daxiang_alert_cycle', '大象告警周期') }}</div>
          <mtdm-select v-model="user_setting.xm_send_cycle">
            <mtdm-option value="WEEK" :label="$getText('wenshu_mobile_one_week', '一周')"/>
            <mtdm-option value="TWO_WEEK" :label="$getText('wenshu_mobile_two_weeks', '两周')"/>
            <mtdm-option value="MONTH" :label="$getText('wenshu_mobile_one_month', '一月')"/>
          </mtdm-select>
          <div class="content-label-title">{{ $getText('wenshu_mobile_citadel_alert_cycle', '学城告警周期') }}</div>
          <mtdm-select v-model="user_setting.km_send_cycle">
            <mtdm-option value="DAY" :label="$getText('wenshu_mobile_one_day', '一天')"/>
            <mtdm-option value="WEEK" :label="$getText('wenshu_mobile_one_week', '一周')"/>
          </mtdm-select>
        </div>
      </div>
      <div slot="bottom-bar" class="slide-footer-bar">
        <mtd-row :gutter="16" style="width: 100%;">
          <mtd-col :span="12">
            <mtdm-button type="secondary" size="middle" @click="close_user_setting">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtdm-button>
          </mtd-col>
          <mtd-col :span="12">
            <mtdm-button type="primary" size="middle" @click="submit_user_setting">{{ $getText('wenshu_mobile_submit', '提交') }}</mtdm-button>
          </mtd-col>
        </mtd-row>
      </div>
    </mtdm-slide-modal>

  </div>
</template>

<script>

import {mapActions} from 'vuex'

export default {
  name: "alert_index",
  data() {
    return {
      alarm_list: [],
      // 分页数据
      query_params: {
        dataSource: null,
        queryDt: null,
        misId: '',
        cn: 1, // 当前页面
        sn: 10, // 每页大小
        tn: 0 // 总条数
      },
      // 用户消息设置
      open_directly_tab: null,
      userSettingShow: false,
      user_setting_visible: false,
      setting_active_tab: 'setting_xm',
      old_user_setting: {
        xm_send_cycle: 'WEEK',
        km_send_cycle: 'DAY'
      },
      user_setting: {
        xm_send_cycle: 'WEEK',
        km_send_cycle: 'DAY'
      },
    }
  },
  mounted: function () {
    document.title = this.$getText('wenshu_mobile_alert_information', '告警信息');
    this.alarm_list = [];
    let query_params = this.$route.query;
    if (query_params) {
      let {dataSource, dt, settingFunction} = query_params;
      if (dataSource === 'xm' || dataSource === 'km') {
        this.query_params.dataSource = dataSource;
      }
      if (dt && (/^\d{8}$/.test(dt))) {
        this.query_params.queryDt = dt;
      }
      if (settingFunction === 'setting_xm' || settingFunction === 'setting_km') {
        this.open_directly_tab = settingFunction;
      }
    }
    this.list_user_file();
    this.load_user_setting();
  },
  methods: {
    // API方法
    ...mapActions({
      api_list_file: 'api_file_trace_query_file',
      api_query_user_setting: 'api_file_trace_query_user_setting',
      api_submit_user_setting: 'api_file_trace_submit_user_setting',
    }),
    list_user_file() {
      this.query_params.size = this.query_params.sn;
      this.query_params.page = this.query_params.cn;
      this.api_list_file(this.query_params).then((res) => {
        if (res.code === 0) {
          let {currentPage, limit, total, items} = res.data;
          this.alarm_list.push(...items);
          this.query_params.cn = currentPage;
          this.query_params.sn = limit;
          this.query_params.tn = total;
        } else {
          this.$mtd.message.error(this.$getText('wenshu_web_failed_to_get_data', '获取数据失败'));
        }
      });
    },
    change_page() {
      this.query_params.cn = this.query_params.cn + 1;
      this.list_user_file()
    },
    show_detail(id, filename) {
      this.$router.push({
          name: "mobile_file_trace_alert_detail",
          params: {file_id: id, filename, dataSource: this.query_params.dataSource, queryDt: this.query_params.queryDt}
        }
      );
    },
    load_user_setting() {
      this.api_query_user_setting().then((res) => {
        let data = res.data;
        if (data) {
          let {xmSetting, kmString} = data;
          this.old_user_setting = {
            xm_send_cycle: xmSetting,
            km_send_cycle: kmString
          }
          this.user_setting = {
            xm_send_cycle: xmSetting,
            km_send_cycle: kmString
          }
          // 判断一下是否直接打开页面
          if (this.open_directly_tab && this.open_directly_tab !== '') {
            this.setting_active_tab = this.open_directly_tab;
            this.open_user_setting();
          }
          this.open_directly_tab = null;
        }
      })
    },
    open_user_setting() {
      this.user_setting_visible = true;
    },
    close_user_setting() {
      this.user_setting_visible = false;
      // 重新加载配置数据
      this.load_user_setting();
      this.setting_active_tab = 'setting_xm';
      this.open_directly_tab = null;
    },
    submit_user_setting() {
      let {xm_send_cycle, km_send_cycle} = this.user_setting;
      let form_data = {xmSetting: xm_send_cycle, kmSetting: km_send_cycle};
      this.api_submit_user_setting(form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_mobile_settings_submitted_successfully', '设置提交成功'));
        this.close_user_setting();
      });
    },
  }
}
</script>

<style>
.index-container {
  background-color: #F5F5F5;
}

.index-header {
  margin-bottom: 12px;
}

.index-list .mtd-card {
  border-radius: 0;
}

.data-show {
  font-family: PingFang SC, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.24);
  font-weight: 400;
  line-height: 20px
}

.index-list .mtd-card-body {
  padding: 12px;
}

.list-card-title {
  font-family: PingFang SC, sans-serif;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.84);
  letter-spacing: 0;
  font-weight: 500;
  line-height: 22px
}

span.list-card-title {
  max-width: calc(100% - 65px);
  display: inline-flex;
}

span.list-card-title span.filename-span {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.slide-content {
  padding: 6px;
  border-radius: 5px;
  background-color: #F5F5F5;
}

.slide-content .content-main {
  background-color: #fff;
  padding: 12px;
}

.slide-footer-bar {
  padding: 12px;
  display: flex;
  width: 100%;
}

.slide-footer-bar .mtdm-button-middle {
  width: 100%;
}

div.content-label-title {
  padding: 6px 10px;
  font-size: 16px;
  font-weight: 500;
}
</style>
